import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Http, Response} from '@angular/http';
import { EventLoggerService } from './event-logger.service';
import { ErrorManagerService } from './error-handling/error-manager.service';


@Injectable()
export class NotificationService {

    constructor(private http: Http, private eventLogger: EventLoggerService, private errorManager: ErrorManagerService) { }

    get(): Observable<any[]> {
        const notificationPath = '../../config/notifications.json';
        return this.http.get(notificationPath)
            .map(this.processResponse);
            // .catch(x => this.handleError(x));
    }

    // private handleError(error: Error): Promise<any[]> {
    //     this.eventLogger.logError(error, error.message, {});
    //     return Observable.of([]).toPromise();
    // }

    private processResponse(response: Response) {
        if (response.status < 200 || response.status >= 300) {
            const error = new Error(response.status + ':' + response.json());
            this.eventLogger.logError(error, error.message, {});
        }
        const body = response.json();
        return body.items || [];
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/notification.service.ts